import permission from './premission'
export default {
  permission
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js